import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import stores from 'cd-eft/models/Stores';
import { PointTranslationByDeltaVM } from './PointTranslationByDeltaVM';
import './PointTranslationByDelta.scss';

const setStore = stores.AppStore.surveyEngineeringStore;

// first Option
export const DeltaCoordinates = observer((props) => {
  const vm = useRef(new PointTranslationByDeltaVM(props)).current;

  return (
    <div className="translation-option-1">
      <div className="point-translation-header">
        <h5 className="my-5">Translate all points in XY and/or Z by user-entered &Delta; values.</h5>
        <h5 className="my-4">Direct Translation</h5>
      </div>

      <div className="form-row-fixed-height justify-content-center mr-2">
        <div className="my-2">Translate Values:</div>

        <InputWithValidation
          label="&Delta;X"
          name="deltaX"
          onChange={vm.handleInputChange}
          errMessage={vm.formValidation.formErrors.deltaX}
          errorClass={vm.errorClass}
          value={setStore.deltaX}
          onBlur={vm.onBlur}
        />
        <InputWithValidation
          label="&Delta;Y"
          name="deltaY"
          onChange={vm.handleInputChange}
          errMessage={vm.formValidation.formErrors.deltaY}
          errorClass={vm.errorClass}
          value={setStore.deltaY}
          onBlur={vm.onBlur}
        />
        <InputWithValidation
          label="&Delta;Z"
          name="deltaZ"
          onChange={vm.handleInputChange}
          errMessage={vm.formValidation.formErrors.deltaZ}
          errorClass={vm.errorClass}
          value={setStore.deltaZ}
          onBlur={vm.onBlur}
        />
      </div>
    </div>
  );
});

const InputWithValidation = (props) => {
  const { label, name, value, onChange, onBlur, errMessage, errorClass } = props;
  return (
    <div className="col col-md-3 display-flex">
      <label className="usa-label px-3" htmlFor={name}>
        {label}
      </label>
      <div className="input-with-validation">
        <input
          data-label={label}
          type="number"
          className={'usa-input' + errorClass(name)}
          placeholder="0.00"
          id={name}
          aria-describedby={`${name}--err`}
          aria-required="true"
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />

        <div className="usa-error-message nobr" id={`${name}--err`} role="alert">
          {errMessage}
        </div>
      </div>
    </div>
  );
};
